export const PageType={
       MAIN_PAGE:'MAIN',
       ATCODER_PAGE:'ATCODER',
       HACKEREARTH_PAGE:'HACKEREARTH',
       CODEFORCES_PAGE:'CODEFORCES',
       CODECHEF_PAGE:'CODECHEF',
       LEETCODE_PAGE:'LEETCODE'
}